module.exports = __webpack_public_path__ + "static/img/f4.323aa0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ui3/f4.png
// module id = SxYZ
// module chunks = 1